import { InfoOutlined } from "@mui/icons-material"
import { Grid, Slider, TextField } from "@mui/material"
import { useIsDesktop } from "common/MediaQueries"
import PropTypes from "prop-types"
import { useState } from "react"
import { NumberFormatBase } from "react-number-format"
import styled from "styled-components"

const StyledSliderContainer = styled(Grid)`
  margin: 0;
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: 85px;
  }
`

const StyledCont = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1px;
  padding-top: 1px;

  ${(p) => p.theme.breakpoints.up("md")} {
    display: grid;
    grid-template-columns: 150px 315px 225px;
    grid-gap: 30px;
    align-items: center;
  }
`

const StyledBetween = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`
const StyledTopText = styled(Grid)`
  font-family: "OENaPro";

  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;

  display: flex;
  align-items: center;
  text-align: right;

  color: ${(p) => p.theme.colors.black};

  flex: none;
  order: 0;
  flex-grow: 0;
`

const StyledUnderText = styled(TextField)`
  width: 132px;
  height: 45px;
  .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: ${(p) => p.theme.colors.darkGrey};
    border-width: 0.5px;
    border-radius: 3px;
    border-style: solid;
  }
  input {
    letter-spacing: normal;
    font-family: "MazdaType", "OENaPro", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    text-align: center;
    color: ${(p) => p.theme.colors.black};
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 150px;
    height: 45px;
  }
`

const StyledUnder = styled(Grid)`
  position: relative;
  top: -20px;
  margin-bottom: 20px;
  color: ${(p) => p.theme.colors.disable};
  font-family: "MazdaType";
  ${(p) => p.theme.breakpoints.up("md")} {
    top: -10px;
  }
`

const StyledDesktopSlider = styled.div`
  width: 100%;
`
export function NumberFormatCustom(props) {
  const { inputRef, onChange, name, shekel, thousandSeparator, ...other } =
    props
  const format = (numStr) => {
    if (numStr === "") return ""
    return shekel
      ? new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "ILS",
          maximumFractionDigits: 0,
        }).format(numStr)
      : numStr + " חודשים"
  }
  return (
    <NumberFormatBase
      {...other}
      name={name}
      format={format}
      isAllowed={(values) => {
        const { floatValue, value } = values
        return (
          value === "" ||
          (floatValue !== undefined &&
            floatValue >= 0 &&
            floatValue <= (name === "months" ? 999 : 999999))
        )
      }}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange(values.value)
      }}
      thousandseparator={thousandSeparator}
    />
  )
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

const CustomSlider = styled(Slider)(() => ({
  "& .MuiSlider-rail": {
    color: "#E7E7E7",
    opacity: 1,
    height: 2,
  },
  "& .MuiSlider-track": {
    color: "#4C607E",
    height: 2,
    transition: "none",
  },
  "& .MuiSlider-thumb": {
    height: 16,
    width: 16,
    backgroundColor: "#fff",
    border: "2px solid #4C607E",
    marginTop: 0,
    marginRight: -8.25,
    transform: "translate(0, -50%)",
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.3)",
    "&:hover, &.Mui-active": {
      boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.3)",
    },
  },
}))

const StyledSliderMargin = styled.div`
  margin: 0 8.5px;
`

const StyledDesktopSliderAlign = styled.div`
  height: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 315px;
`

const StyledTopTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledOptional = styled.p`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 130%;
  margin: 0;
  color: #616161;
`

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  color: #999999;
  background-color: transparent;
  border: none;
  font-size: 20px;
`

const StyledSubHeaderContainer = styled.div`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: #616161;
  margin-top: 20px;
  margin-bottom: 10px;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-family: OENaPro;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 130%;
    text-align: right;
    color: #616161;
    max-width: 165px;
    margin-bottom: 40px;
    margin-top: -20px;
  }
`

type Props = {
  low: number
  high: number
  label: string
  shekel: boolean
  formik: any
  id: string
  handleChange: (val, id) => void
  disabled?: boolean
  optional?: boolean
  toolTipText?: string
  step?: number
  secondHigh?: number
}
export default function FinanceSlider({
  low = 0,
  high = 200,
  label = "תשלום ראשון",
  shekel,
  formik,
  id,
  handleChange,
  disabled,
  optional,
  toolTipText,
  step,
  secondHigh,
}: Props) {
  const isDesktop = useIsDesktop()
  const [isSubHeaderOpen, setIsSubHeaderOpen] = useState(false)

  const handleSubClick = () => {
    setIsSubHeaderOpen(!isSubHeaderOpen)
  }

  const handleInputChange = (e) => {
    const val = Number(e.target.value.replace("₪", "").replace(/,/g, ""))
    if (val >= high) {
      handleChange(Number(high), id)
      return
    }

    if (val <= low) {
      handleChange(Number(low), id)
      return
    }

    handleChange(e.target.value === "" ? "" : val, id)
  }

  return (
    <>
      <StyledSliderContainer>
        <StyledCont>
          <StyledTopTextContainer>
            <StyledTopText>
              {label}
              {toolTipText && (
                <StyledButton onClick={handleSubClick} aria-label="מידע נוסף">
                  <InfoOutlined
                    fontSize="inherit"
                    style={{ color: "#616161", fill: "#616161" }}
                  />
                </StyledButton>
              )}
            </StyledTopText>

            {optional && <StyledOptional>אופציונלי</StyledOptional>}
          </StyledTopTextContainer>
          {isDesktop ? (
            <StyledDesktopSliderAlign>
              <StyledDesktopSlider>
                <StyledSliderMargin>
                  <CustomSlider
                    disabled={disabled}
                    min={id === "defaultMonthlyPayment" ? 0 : low}
                    max={
                      id === "defaultMonthlyPayment"
                        ? 8000
                        : id === "endOfPeriodPayment"
                        ? secondHigh
                        : high
                    }
                    step={step ? step : !shekel ? 12 : 1}
                    value={
                      formik.values[id] !== undefined ? formik.values[id] : low
                    }
                    onChange={(e, val: number) => {
                      if (val >= high) {
                        handleChange(Number(high), id)
                        return
                      }

                      if (val <= low) {
                        handleChange(Number(low), id)
                        return
                      }

                      handleChange(val, id)
                    }}
                  />
                </StyledSliderMargin>

                {shekel ? (
                  <StyledBetween>
                    <StyledUnder>
                      {id === "defaultMonthlyPayment"
                        ? "0"
                        : Math.round(low).toLocaleString("en-US")}
                    </StyledUnder>
                    <StyledUnder>
                      {id === "defaultMonthlyPayment"
                        ? "8,000"
                        : id === "endOfPeriodPayment"
                        ? secondHigh?.toLocaleString("en-US") ?? "0"
                        : Math.round(high).toLocaleString("en-US")}
                    </StyledUnder>
                  </StyledBetween>
                ) : (
                  <StyledBetween>
                    <StyledUnder>24</StyledUnder>
                    <StyledUnder>36</StyledUnder>
                    <StyledUnder>48</StyledUnder>
                    <StyledUnder>60</StyledUnder>
                  </StyledBetween>
                )}
              </StyledDesktopSlider>
            </StyledDesktopSliderAlign>
          ) : null}
          <StyledUnderText
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                handleInputChange(event)
              }
            }}
            disabled={disabled || !shekel}
            aria-disabled={disabled || !shekel}
            value={formik.values[id]}
            onChange={(text) => formik.setFieldValue(id, text)}
            onBlur={handleInputChange}
            inputProps={{
              name: id,
              shekel,
              "aria-labelledby": "input-slider",
              "aria-label": `${label}`,
            }}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
        </StyledCont>

        {!isDesktop ? (
          <>
            {toolTipText && isSubHeaderOpen && (
              <StyledSubHeaderContainer>{toolTipText}</StyledSubHeaderContainer>
            )}
            <StyledSliderMargin>
              <CustomSlider
                disabled={disabled}
                min={id === "defaultMonthlyPayment" ? 0 : low}
                max={high}
                step={!shekel ? 12 : 1}
                value={formik.values[id]}
                onChange={(e, val) => handleChange(val, id)}
              />
            </StyledSliderMargin>
            {shekel ? (
              <StyledBetween>
                <StyledUnder>
                  {id === "defaultMonthlyPayment"
                    ? "0"
                    : Math.round(low).toLocaleString("en-US")}
                </StyledUnder>
                <StyledUnder>
                  {Math.round(high).toLocaleString("en-US")}
                </StyledUnder>
              </StyledBetween>
            ) : (
              <StyledBetween>
                <StyledUnder>24</StyledUnder>
                <StyledUnder>36</StyledUnder>
                <StyledUnder>48</StyledUnder>
                <StyledUnder>60</StyledUnder>
              </StyledBetween>
            )}
          </>
        ) : null}
      </StyledSliderContainer>
      {isDesktop && toolTipText && isSubHeaderOpen && (
        <StyledSubHeaderContainer>{toolTipText}</StyledSubHeaderContainer>
      )}
    </>
  )
}
